import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function PricingCard() {
  return <section id="offer" className="border-y-4 border-golf-lime bg-golf-light px-4 py-4" data-id="element-102" data-mp="1m4t9m0pdxwce">
      <div className="mx-auto max-w-2xl" data-id="element-103" data-mp="1i40z744s1lej">
        <div className="mb-2 text-center" data-id="element-104" data-mp="2esyx2v7tpzfx">
          <p className="mb-0.5 font-head text-[11px] font-bold uppercase tracking-[0.18em] text-golf-gold sm:text-sm" data-id="element-105" data-mp="2erx9xsdj9mhu">
            Special Launch Offer
          </p>
          <h2 className="mb-0.5 font-display text-3xl font-extrabold uppercase leading-none tracking-tight sm:text-5xl" data-id="element-106" data-mp="252x7fyzto8yw">
            GOLF COACH PRO™
          </h2>
          <p className="mb-1.5 font-head text-[13px] font-semibold uppercase text-golf-green sm:text-lg" data-id="element-107" data-mp="211bphz8fl4hu">
            Complete 6-in-1 Golf Coaching System
          </p>
          <a href={CHECKOUT_URL} className="block" aria-label="Buy GOLF COACH PRO™" data-id="element-108" data-mp="2sros85b31p1n">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto mb-2 w-full max-w-[230px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-[260px]" data-id="element-109" data-mp="32k2ir7nfzz4l" />
          </a>
        </div>

        <div className="mb-2 rounded-xl border-4 border-golf-lime bg-white p-4 text-center shadow-2xl" data-id="element-110" data-mp="2xt3wlrfrw6tf">
          <ul className="mb-1.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-[13px] font-semibold text-golf-green sm:text-base" data-id="element-111" data-mp="2jtl2w3npky0n">
            <li data-id="element-112" data-mp="2oquqrevg91md">✅ 6 Complete Modules</li>
            <li data-id="element-113" data-mp="29w6kvzm50168">✅ 5 Premium Bonuses</li>
          </ul>
          <p className="text-[13px] font-medium text-golf-muted" data-id="element-114" data-mp="29xrijy3r008b">
            Regular Price: <span className="line-through" data-id="element-115" data-mp="2ev9s9qplajhd">{PRICE_FULL}</span>
          </p>
          <p className="mb-2.5 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-golf-lime sm:text-4xl" data-id="element-116" data-mp="85d2z5oof7v2">
            🔥 TODAY ONLY: {PRICE_TODAY}
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-117" data-mp="bmhko5qaok04">🚀 YES! I WANT GOLF COACH PRO™</CTAButton>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-golf-green sm:text-sm" data-id="element-118" data-mp="6mv87yiaj7sd">
          <span className="flex items-center gap-1" data-id="element-119" data-mp="1obkpto1tnxw">
            <StarIcon className="h-4 w-4 fill-golf-gold text-golf-gold" aria-hidden="true" data-id="element-120" data-mp="3tscdkf3m9pg9" />
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </span>
          <span className="flex items-center gap-1" data-id="element-121" data-mp="uetiqg9x0z4g">
            <ShieldCheckIcon className="h-4 w-4 text-golf-lime" aria-hidden="true" data-id="element-122" data-mp="penocsc9gyio" />
            🛡️ 14-Day Money-Back Guarantee
          </span>
        </div>
      </div>
    </section>;
}